export const GENERATE_RETURN_NUMBER = "GENERATE_RETURN_NUMBER";

export const onGenerateReturnNumber = (payload) => {
  return {
    type: GENERATE_RETURN_NUMBER,
    payload,
  };
};
